<template>
  <!-- <v-card rounded="lg">
    <v-card-text> -->
  <v-form v-model="valid" ref="goodsFormComponent">
    <v-row>
      <v-col cols="12">
        <search-goods-map-field
          v-model="form.map"
          placeholder="Cerca la merce"
          solo
          append-icon="mdi-magnify"
          class="rounded-lg"
          required
          single-line
          outlined
          v-show="search || !form.map"
          @change="search = false"
          disable-icon-rotate
          :rules="mapRules"
          :disabled="!canChangeTypes"
        />
        <v-select
          label="Classificazione TMS della merce"
          v-model="form.type"
          :items="goodsTypeItems"
          item-value="id"
          item-text="desc"
          class="rounded-lg"
          required
          outlined
          v-show="!search && form.map"
          :hint="(form.map && form.map.mrc_des) || null"
          persistent-hint
          :disabled="!canChangeTypes"
        >
          <template #append>
            <v-icon color="success">mdi-check</v-icon>
          </template>
        </v-select>
        <div class="text-right mt-n6" v-if="form.map && canChangeTypes">
          <v-btn @click="search = !search" depressed small class="ml-auto">{{ search ? 'annulla' : 'cambia' }}</v-btn>
        </div>
      </v-col>
      <v-col cols="12" v-if="form.type">
        <v-select
          label="Aspetto del carico"
          v-model="form.aspect"
          :items="cargoTypeItems"
          item-value="id"
          item-text="desc"
          outlined
          placeholder="Seleziona un aspetto del carico"
          class="rounded-lg required"
          :rules="[required]"
          required
          dense
          :disabled="!canChangeTypes"
        />
      </v-col>
      <v-col cols="12" v-if="false">
        <v-select
          label="Pericolosità"
          v-model="form.dangerous"
          :items="dangerousTypes"
          item-value="id"
          item-text="desc"
          outlined
          class="rounded-lg required"
          dense
        />
      </v-col>
    </v-row>

    <!-- GOODS -->
    <v-row no-gutters v-if="form.aspect">
      <!-- MULTI -->
      <template v-if="multi">
        <v-col cols="5" class="text--secondary">
          <div class="text-body-1 text--primary">Merce <strong>caricata</strong> <span class="red--text">*</span></div>
          nella località di <strong>partenza</strong></v-col
        >
        <v-col cols="4" class="text-caption">
          <div class="rounded-lg blue lighten-5 mx-2 mr-5 px-2 py-1" v-if="form.weights.onboard > 0">
            <div class="text-body-2 text--primary pb-0 mb-n1">
              <strong>{{ form.weights.onboard }}</strong
              >q già a bordo
            </div>
            dal viaggio precedente
          </div>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model.number="form.weights.loaded"
            type="number"
            outlined
            dense
            class="rounded-lg required hide-arrows"
            :rules="loadedRules"
            persistent-hint
            hint="in quintali"
            suffix=",00"
            @keypress="isNumber($event)"
          >
            <template #append-outer>
              <div class="mt-1 text-no-wrap"><i>q</i></div>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="5" class="text--secondary">
          <div class="text-body-1 text--primary">Merce <strong>scaricata</strong> <span class="red--text">*</span></div>
          nella località di <strong>arrivo</strong>
        </v-col>
        <v-col cols="4" class="text-caption">
          <div class="rounded-lg blue lighten-5 mx-2 mr-5 px-2 py-1" v-if="onboardAtDeparture > 0">
            <div class="text-body-2 text--primary pb-0 mb-n1">
              <strong>{{ onboardAtDeparture }}</strong
              >q a bordo
            </div>
            all'arrivo
          </div>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model.number="form.weights.unloaded"
            type="number"
            outlined
            dense
            class="rounded-lg required hide-arrows"
            :rules="unloadedRules"
            persistent-hint
            hint="in quintali"
            suffix=",00"
            @keypress="isNumber($event)"
          >
            <template #append-outer>
              <div class="mt-1 text-no-wrap"><i>q</i></div>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <div v-if="remainingOnboard > 0">
            <v-alert dense text type="info" class="mt-4">
              Rimangono a bordo ancora <strong>{{ remainingOnboard }}</strong> quintali di merce. Tale rimanenza dovrà
              essere scaricata in un viaggio successivo.
            </v-alert>
          </div>
        </v-col>
      </template>
      <!-- MONO -->
      <template v-else>
        <v-col cols="9" class="text-body-1"> Merce trasportata (quintali) <span class="red--text">*</span></v-col>
        <v-col cols="3">
          <v-text-field
            v-model.number="form.weight"
            type="number"
            outlined
            dense
            class="rounded-lg required hide-arrows"
            :rules="weightRules"
            persistent-hint
            hint="in quintali"
            suffix=",00"
            @keypress="isNumber($event)"
          >
            <template #append-outer>
              <div class="mt-1 text-no-wrap"><i>q</i></div>
            </template>
          </v-text-field>
        </v-col>
      </template>
    </v-row>
    <small v-if="form.type"
      ><span class="red--text">*</span> <span class="text--secondary">indica i campi obbligatori</span></small
    >

    <v-alert type="warning" text v-if="isAlreadyOnboard" class="mt-3" icon="mdi-alert-circle">
      A bordo esiste già una merce con la stessa classificazione e aspetto. <br />
      Se queste merci verranno scaricate tutte nella stessa località è possibile riportarle come un'unica merce.
    </v-alert>
  </v-form>
</template>

<script>
// Models
import { createGoodsInstance } from '@/models'

// Components
import SearchGoodsMapField from '@/components/forms/SearchGoodsMapField.vue'

// Types
import { goodsTypes, cargoTypes, dangerousTypes } from '@/types'

// Validations
import { required, number, min } from '@/validations'

// Component
export default {
  name: 'GoodsMapForm',
  components: {
    SearchGoodsMapField,
  },
  data() {
    return {
      dialog: false,
      valid: false,
      result: null,
      entries: [],
      form: createGoodsInstance(),
      search: false,
      submitted: false,

      goodsTypes,
      cargoTypes,
      dangerousTypes,

      weightRules: [number, min(1)],
      required,
    }
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    multi: {
      type: Boolean,
      default: false,
    },
    alreadyOnboardGoods: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.form = Object.assign({}, this.form, JSON.parse(JSON.stringify(this.value)))
  },
  watch: {
    value(val) {
      this.form = Object.assign({}, this.form, JSON.parse(JSON.stringify(val)))
    },
    'form.map': {
      immediate: true,
      deep: true,
      handler(value) {
        if (!value) return
        this.form.type = value.cod_mrc
        this.form.dangerous = value.has_only_one_mrc_prcs ? value.cod_mrc_prcs[0] : null

        if (value.has_only_one_aspt_crc) {
          this.form.aspect = value.cod_aspt_crc[0]
          return
        }
        if (!this.form.aspect) return
        if (!value.cod_aspt_crc.includes(this.form.aspect)) this.form.aspect = null
      },
    },
  },
  computed: {
    goodsTypeItems() {
      return this.form.map?.cod_mrc ? goodsTypes.filter((t) => t.id === this.form.map?.cod_mrc) : []
    },
    cargoTypeItems() {
      return this.form.map?.cod_aspt_crc
        ? cargoTypes.filter((t) => this.form.map?.cod_aspt_crc.indexOf(t.id) !== -1)
        : []
    },
    onboardAtDeparture() {
      return this.form.weights.onboard + this.form.weights.loaded
    },
    remainingOnboard() {
      return this.onboardAtDeparture - this.form.weights.unloaded
    },
    loadedRules() {
      return [min(0)]
    },
    unloadedRules() {
      return [min(0), (v) => v <= this.onboardAtDeparture || `Max qta scaricabile ${this.onboardAtDeparture}q`]
    },
    mapRules() {
      return [required]
    },
    canChangeTypes() {
      return !(this.form.is_inherited || this.readonly)
    },
    isAlreadyOnboard() {
      return !!this.alreadyOnboardGoods.find((o) => o.type === this.form.type && o.aspect === this.form.aspect)
    },
  },
  methods: {
    _setForm(value) {
      this.form = Object.assign({}, createGoodsInstance, JSON.parse(JSON.stringify(value)))
    },
    async validate() {
      await this.$refs.goodsFormComponent?.validate()
      this.$emit('validate', this.valid)

      return this.valid
    },
    async submit() {
      this.submitted = true
      const valid = await this.validate()

      if (!valid) return

      if (this.multi) {
        this.form.weight = null
        this.form.weights.remaining = this.remainingOnboard
      } else {
        this.form.weights = {
          loaded: null,
          unloaded: null,
          onboard: 0,
          remaining: 0,
        }
      }

      this.$emit('submit', this.form)
      this.$emit('input', this.form)
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .required .v-label--active:after {
  content: ' *';
  color: red;
  background-color: white;
  padding-right: 1px;
}
::v-deep .required .v-label:after {
  content: ' *';
  color: red;
  padding-right: 1px;
}

::v-deep .hide-arrows {
  input[type='number'] {
    text-align: right;
    font-weight: bold;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>
